import { Component } from '@theme/component';

class InksakeEditorialNav extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.addEventListener('keydown', this.#onKeydown, options);
    this.addEventListener('click', this.#onClick, options);
    this.addEventListener('focusout', this.#onFocusOut, options);
    this.addEventListener('toggle', this.#onToggle, { ...options, capture: true });
    document.addEventListener('pointerdown', this.#onOutside, options);
    this.closest('header-component')?.addEventListener('click', this.#onHeaderAction, options);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #close(restoreFocus = false, except = null) {
    const disclosures = [...this.querySelectorAll('details[open]')].filter((item) => item !== except);
    const activeDisclosure = disclosures.find((item) => item.contains(document.activeElement)) || disclosures[0];
    for (const disclosure of disclosures) disclosure.open = false;
    if (restoreFocus) activeDisclosure?.querySelector('summary')?.focus();
  }

  #onToggle = (event) => {
    const disclosure = event.target;
    if (disclosure instanceof HTMLDetailsElement && disclosure.open) this.#close(false, disclosure);
  };

  #onKeydown = (event) => {
    if (event.key !== 'Escape') return;
    if (!this.querySelector('details[open]')) return;
    event.preventDefault();
    event.stopPropagation();
    this.#close(true);
  };

  #onClick = (event) => {
    const summary = event.target.closest('summary');
    if (summary && this.contains(summary)) this.#close(false, summary.closest('details'));
    if (event.target.closest('.inksake-editorial-nav__close')) this.#close(true);
    if (event.target.closest('a')) this.#close();
  };

  #onFocusOut = (event) => {
    const disclosure = event.target.closest('details[open]');
    if (disclosure && this.contains(disclosure) && event.relatedTarget && !disclosure.contains(event.relatedTarget)) this.#close();
  };

  #onOutside = (event) => {
    if (!this.contains(event.target)) this.#close();
  };

  #onHeaderAction = (event) => {
    if (!this.contains(event.target) && event.target.closest('button, a, shopify-account')) this.#close();
  };
}

if (!customElements.get('inksake-editorial-nav')) {
  customElements.define('inksake-editorial-nav', InksakeEditorialNav);
}
